function Textarea({
  value,
  rows,
  onChange,
  placeholder,
  className,
  onKeyPress,
  onBlur,
  innerRef,
}) {
  return (
    <textarea
      rows={rows}
      cols="50"
      ref={innerRef}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={`rounded-lg p-2 resize-none flex-1 ${className}`}
      onKeyPress={onKeyPress}
      onBlur={onBlur}
    />
  );
}

export default Textarea;
